export default [
    {
        path: '/system/codes',
        name: 'code-management',
        component: () => import('../../pages/system/CodePage.vue'),
        meta: {
            title: 'Code Management',
            requiresAuth: true,
        },
    },
]
